/**
 * Function to test whether the component is shown in AEM edit mode or not.
 *
 * @param parent (any)
 *
 * @returns boolean
 */
import { ComponentPublicInstance } from 'vue/types/v3-component-public-instance';
import { Vue } from 'vue/types/vue';

export function isAemEditMode(parent: Vue | ComponentPublicInstance): boolean {
  if (parent) {
    const options = parent.$options as any;
    if (options?.customElement?.getAttribute('data-edit-mode')) {
      return true;
    }
  }
  return false;
}
